"use client";

import { useRef } from "react";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGalleryOfDigitalExcellence() {
  const projects = [{
    id: 1,
    name: "Singapore Logistics Hub",
    year: 2024,
    industry: "Construction Logistics",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/singapore_logistics_hub.png",
    colSpan: 2
  }, {
    id: 2,
    name: "Dubai Infrastructure",
    year: 2023,
    industry: "Project Management",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/dubai_infrastructure.png",
    colSpan: 1
  }, {
    id: 3,
    name: "London Tech Park",
    year: 2024,
    industry: "Resource Allocation",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/london_tech_park.png",
    colSpan: 1
  }, {
    id: 4,
    name: "Sydney Port Expansion",
    year: 2023,
    industry: "Global Operations",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/sydney_port_expansion.png",
    colSpan: 1
  }, {
    id: 5,
    name: "Berlin Industrial Complex",
    year: 2024,
    industry: "Strategic Coordination",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/berlin_industrial_complex.png",
    colSpan: 2
  }, {
    id: 6,
    name: "Tokyo Smart City",
    year: 2023,
    industry: "Urban Development",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648747/img/tokyo_smart_city.png",
    colSpan: 1
  }];
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    ref: galleryRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237206" id="project-showcase" className="dark bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8" ref={containerRef}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <h1 className="font-default text-4xl sm:text-5xl font-bold mb-4 tracking-tight uppercase">
            Global Project Portfolio
          </h1>
          <p className="font-default text-lg text-secondary max-w-2xl mx-auto">
            A showcase of our worldwide consultancy impact, delivering precision in logistics and management
          </p>
        </div>

        <div ref={galleryRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 auto-rows-max">
          {projects.map((project, i) => <div key={project.id} data-index={i} className={`${project.colSpan === 2 ? "lg:col-span-2" : "lg:col-span-1"} ${isVisible ? "opacity-100" : "opacity-0"} transition-opacity duration-500`}>
              <Card className="overflow-hidden bg-card border border-white/5 rounded-md h-full shadow-lg">
                <div className="relative overflow-hidden">
                  <AspectRatio ratio={4 / 5}>
                    <img src={project.image} alt={project.name} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 hover:scale-105 brightness-75 hover:brightness-100" />
                  </AspectRatio>

                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-500 backdrop-blur-[2px]" />

                  <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 hover:translate-y-0 transition-transform duration-500 opacity-0 hover:opacity-100">
                    <Badge variant="secondary" className="bg-primary text-primary-foreground border-none rounded-sm font-mono text-xs">
                      {project.industry}
                    </Badge>
                  </div>
                </div>

                <div className="p-6">
                  <h2 className="font-default text-xl font-semibold mb-2 tracking-tight">
                    {project.name}
                  </h2>
                  <p className="font-mono text-sm text-secondary">
                    {project.year}
                  </p>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}